// extracted by mini-css-extract-plugin
module.exports = {"modelInfo":"ModelInfo_modelInfo__1vkaq","message":"ModelInfo_message__LcxOg"};